import styles from './Header.module.css';

const ASSETS_URL = import.meta.env.VITE_ASSETS_URL;

export function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.logos}>
        <img className={styles.zenidLogo} src={`${ASSETS_URL}/assets/images/zenid_logo.svg`} alt="ZEN IDロゴ" />
        <img
          className={styles.kadokawaLogo}
          src={`${ASSETS_URL}/assets/images/kadokawa_group_logo.svg`}
          alt="KADOKAWA Groupのロゴ"
        />
      </div>
    </header>
  );
}
